import React, { Component, lazy, Suspense } from "react";
import { Provider } from "react-redux";
import CakeStore from "./store";
import PropTypes from "prop-types";
import {
	HashRouter as Router,
	Route,
	Switch,
	Link,
	BrowserRouter,
	Redirect,
	HashRouter,
} from "react-router-dom";
const OnboardingEmailEditor = lazy(() =>
	import("assets/js/scenes/OnBoardingFlow/components/OnboardingEmailEditor")
);
import Cookies from "universal-cookie";
import { loadTranslations, syncTranslationWithStore } from "react-redux-i18n";
const Contacts = lazy(() => import("./scenes/contacts/Contacts"));
const Forms = lazy(() => import("./scenes/forms/Forms"));
import Menu from "./containers/Menu/Menu";
const Dashboard = lazy(() => import("./scenes/dashboard/Dashboard"));
const ResellerDashboard = lazy(() =>
	import("assets/js/scenes/reseller/dashboard/ResellerDashboard")
);
const Campaigns = lazy(() => import("./scenes/campaigns/Campaigns"));
const Account = lazy(() => import("./scenes/account/Account"));
const AuthFlow = lazy(() => import("./scenes/authFlow/AuthFlow"));
const BlockedUser = lazy(() =>
	import("assets/js/containers/ErrorFallback/BlockedUser")
);
import {
	setAccount,
	setUser,
	setBrandPreview,
	setCustomer,
	setAuthenticated,
	setAccountReady,
	setAccountMetadata,
} from "./actions";
import TaskBarContainer from "./containers/TaskBarContainer";
import { connect } from "react-redux";
import * as moment from "moment-timezone";
import { Translate } from "react-redux-i18n";
import {
	Notification,
	NotificationHandler,
	Dialog,
	DialogHandler,
	FullPageLoader,
	FullPageLoaderHandler,
	OverlayHandler,
	Overlay,
	TaskBarHandler,
	TaskBar,
} from "cakemail-ui-components/lib/react";

import CriticalError from "./CriticalError";
import {
	getAccountUsage,
	getAmplitudeMonthlyStats,
	openBillingPortal,
	globalLogOut,
} from "utils/apiUtils";
import fetchRoute from "utils/routes";
import locizer from "locizer";
import locizeEditor from "locize-editor";
import { addLocizeSavedHandler } from "locize";
import {
	adjustLocaleToMatchBE,
	fallBackLanguage,
	setLocaleWithFallback,
} from "utils/languages";
const Automation = lazy(() =>
	import("assets/js/scenes/automations/Automations")
);
import { getUrlQueryParam, removeLegacyParameterByName } from "utils/urlUtils";
const Lists = lazy(() => import("assets/js/scenes/lists/Lists"));
import {
	SEGMENT_EVENTS,
	segmentCondition,
	segmentPayloads,
	trackSegmentEvent,
} from "assets/js/const/SegmentEvents";
import {
	createAccountMetaDataService,
	getAccountMetaDataService,
	getBillingCustomer,
	openStripeBillingCheckout,
} from "assets/js/services/hiddenService";
import { ACCOUNT_META } from "assets/js/const/MetaData";
import { loadAppcues, newScript } from "assets/js/scenes/OnBoardingFlow/utils";
import Brand from "assets/js/scenes/brand/Brand";
const PublicHash = lazy(() => import("assets/js/scenes/publicHash/PublicHash"));
import { whoami } from "assets/js/services/accountService";
import {
	imILoggedIn,
	impersonateService,
	logoutService,
} from "assets/js/services/authService";
import { getPlanType } from "utils/LimitsAndFeatures";
import { clearGlobalItems } from "utils/componentUtils";
import {
	createBrandService,
	getUserBrandSDK,
	getUserBrandService,
	updateUserBrandConfig,
} from "assets/js/services/brandingService";
import { setUserBrand } from "assets/js/data/userBranding/actions";
import userDefaultBrand from "assets/js/scenes/brand/data/userDefaultBrand";
import SpinnerContainer from "assets/js/components/SpinnerContainer";
import { isMobile } from "react-device-detect";
import NoMobile from "assets/js/containers/NoMobile";
import { posthog } from "posthog-js";

class UI extends Component {
	constructor(props) {
		super(props);

		this.cookies = new Cookies();
		this.usageInterval = null;

		this.handleState = this.handleState.bind(this);
		this.fetchAccount = this.fetchAccount.bind(this);
		this.logOut = this.logOut.bind(this);
		this.tabActivated = this.tabActivated.bind(this);
		this.tabInactive = this.tabInactive.bind(this);
		this.setTranslationLocale = this.setTranslationLocale.bind(this);
		this.setPreviewingBrand = this.setPreviewingBrand.bind(this);
		this.identifyInit = this.identifyInit.bind(this);
		this.initAccountAndUser = this.initAccountAndUser.bind(this);

		this.state = {
			error: false,
			// flag to indicate wether downloading translations from locize is completed or not
			doneLoadingTranslations: false,
			// state holding the translations either from locize or from translation files if locize failed for any reason
			translations: null,
			intervals: {
				usage: 30000,
			},
			previewingBrand: false,
		};
		newScript(
			"https://maps.googleapis.com/maps/api/js?key=AIzaSyB0huXDRyok1Sv8D6TxBH9jLUDJu98-8RM&libraries=places"
		);

		this.validateSession();
	}

	componentDidUpdate() {
		if (this.state.doneLoadingTranslations) {
			syncTranslationWithStore(CakeStore);
			CakeStore.dispatch(loadTranslations(this.state.translations));
			this.setTranslationLocale();
			this.setState({ doneLoadingTranslations: false });
		}
		return null;
	}

	componentDidMount() {
		NotificationHandler.register(this.refs.Notification);
		DialogHandler.register(this.refs.Dialog);
		OverlayHandler.register(this.refs.Overlay);
		TaskBarHandler.register(this.refs.Taskbar);
		FullPageLoaderHandler.register(this.refs.fullPageLoader);
		this.initLocizer();

		window.addEventListener("focus", this.tabActivated);
		window.addEventListener("blur", this.tabInactive);
	}

	setPreviewingBrand(preview = false) {
		CakeStore.dispatch(setBrandPreview(preview));
		this.setState({
			previewingBrand: preview,
		});
	}

	setTranslationLocale(userLocale = null) {
		const urlLocale = getUrlQueryParam("locale");
		const cookieLocale = this.cookies.get("locale");

		let finalLocale = null;
		// Language Priority : User -> Url -> Cookie -> Browser -> fallback
		if (userLocale) {
			finalLocale = userLocale;
		} else if (urlLocale) {
			finalLocale = urlLocale;
		} else if (cookieLocale) {
			finalLocale = cookieLocale;
		}

		//Browser and fallback are checked in setLocaleWithFallback
		CakeStore.dispatch(setLocaleWithFallback(finalLocale));
		removeLegacyParameterByName("locale");
	}

	componentWillUnmount() {
		clearGlobalItems();
		clearInterval(this.usageInterval);
		this.usageInterval = null;
	}

	initLocizer = () => {
		try {
			FullPageLoaderHandler.show();
			locizer.init({
				fallbackLng: fallBackLanguage,
				referenceLng: fallBackLanguage,
				loadIfTranslatedOver: -1,
				projectId: process.env.LOCIZE_PORJECT_ID,
				version: process.env.LOCIZE_PORJECT_VERSION,
				// we don't use this order, we are handling the order manually , yet this parameter is required
				// by locize to initialize
				// we don't use locizer order because the localization library 'react-redux-i18n' requires all the translations
				// to be loaded on initialization, while locize order handles loading by retrieving only the language based on the
				// order provided to it
				//TODO : when changing the localization library we need to consider selecting another one that can use
				// locize order i.e doesn't require all translations to be loaded at first
				order: ["querystring"],
				lookupQuerystring: "lng",
			});

			let translations = {};

			locizer.getLanguages((err, lngs) => {
				Object.keys(lngs).forEach((lng) => {
					locizer.load("translations", lng, (err, messages, locale) => {
						translations[adjustLocaleToMatchBE(locale)] = messages;

						if (Object.keys(translations).length == Object.keys(lngs).length) {
							this.setState({ translations: translations });
							this.setState({ doneLoadingTranslations: true });
							FullPageLoaderHandler.hide();
						}
					});
				});
			});
			addLocizeSavedHandler((res) => {
				res.updated.forEach((item) => {
					const { lng, ns, key, data } = item;
					// load the translations somewhere...
					// and maybe rerender your UI
				});
			});
			locizeEditor.init({
				toggleKeyModifier: "ctrlKey",
				toggleKeyCode: 24,
				lng: fallBackLanguage,
				defaultNS: "translations",
				projectId: process.env.LOCIZE_PORJECT_ID,
				referenceLng: fallBackLanguage,
				onEditorSaved: function (lng, ns) {
					location.reload();
				},
			});
		} catch (err) {
			const translations = require("./translations.json");
			syncTranslationWithStore(CakeStore);
			CakeStore.dispatch(loadTranslations(translations));

			this.setTranslationLocale(null);

			FullPageLoaderHandler.hide();
		}
	};

	validateSession() {
		imILoggedIn(
			{},
			(data) => {
				if (data.data.loggedIn) {
					const impersonatedAccountId = getUrlQueryParam("impersonate");
					if (impersonatedAccountId) {
						impersonateService(
							{
								accountId: impersonatedAccountId,
							},
							() => {
								removeLegacyParameterByName("impersonate");
								this.fetchAccount();
							},
							() => {
								DialogHandler.show({
									type: "error",
									title: <Translate value="app-general-impersonate-error" />,
								});
								this.fetchAccount();
							}
						);
					} else {
						this.fetchAccount();
					}
				} else {
					CakeStore.dispatch(setAuthenticated(false));
				}
			},
			() => {
				CakeStore.dispatch(setAuthenticated(false));
			}
		);
	}

	handleState(name, value) {
		this.setState({
			[name]: value,
		});
	}

	fetchAccount(
		callback = () => {},
		skipAuthSetup = false,
		impersonate = false
	) {
		const localCheckout =
			window.localStorage.getItem("checkout") || getUrlQueryParam("checkout");

		whoami(
			null,
			(response) => {
				const data = response.data;

				if (localCheckout) {
					history.replaceState(null, "", window.location.origin);
					FullPageLoaderHandler.show();
					let url =
						window.location.origin +
						`?prev_limits=${data.account.usage_limits.maximum_contacts},${data.account.usage_limits.per_month}#/`;
					getBillingCustomer(
						{
							parentAccountId:
								CakeStore.getState().brand?.config?.partner_account_id,
						},
						(stripeData) => {
							if (stripeData?.data?.subscriptions?.data?.length === 0) {
								let url =
									window.location.origin +
									`?prev_limits=${data.account.usage_limits.maximum_contacts},${data.account.usage_limits.per_month}#/`;
								openStripeBillingCheckout(
									{
										returnToUrl: url,
										price: localCheckout,
										parentAccountId:
											CakeStore.getState().brand?.config?.partner_account_id,
									},
									(result) => {
										trackSegmentEvent(SEGMENT_EVENTS.CHECKOUT_STARTED, {
											account: data?.account,
											user: data?.user,
											customer: stripeData.data,
											price: localCheckout,
										});
										window.location.replace(result?.data?.checkout_url);
										setTimeout(() => {
											FullPageLoaderHandler.hide();
										}, 1000);
									},
									() => {
										FullPageLoaderHandler.hide();
									}
								);
							} else {
								trackSegmentEvent(SEGMENT_EVENTS.CHECKOUT_STARTED, {
									account: data?.account,
									user: data?.user,
									price: localCheckout,
									customer: stripeData.data,
								});
								openBillingPortal(null, null, localCheckout, true);
							}
						},
						() => {
							FullPageLoaderHandler.hide();
						}
					);

					window.localStorage.removeItem("checkout");
				}

				this.initAccountAndUser(data.account, data.user);

				if (!data.account?.partner) {
					getUserBrandService(
						{ id: data.account.id },
						(userBrand) => {
							CakeStore.dispatch(setUserBrand(userBrand));
							if (
								userBrand?.config?.usage_limits?.insert_reseller_logo !==
								data.account.usage_limits?.insert_reseller_logo
							) {
								updateUserBrandConfig({ accountId: data.account.id });
							}

							if (userBrand?.client_config?.brand_repo?.url) {
								getUserBrandSDK(
									{ url: userBrand.client_config.brand_repo?.url },
									() => {},
									(msg) => {
										DialogHandler.show({
											type: "error",
											title: (
												<Translate
													value={
														msg
															? msg
															: "app-brand-settings-brand-repo-fetch-error"
													}
												/>
											),
										});

										window.location = "#/" + fetchRoute("dashboard");
									}
								);
							}
						},
						(msg, error, code) => {
							if (error?.status === 404) {
								createBrandService(
									{
										id: data.account.id,
										brand: userDefaultBrand,
									},
									(data) => {
										CakeStore.dispatch(setUserBrand(data));
									},
									(msg, error, code) => {}
								);
							}
						}
					);
				}

				const p1 = new Promise((resolve) => {
					getAmplitudeMonthlyStats(data.account, (stats) => {
						resolve(stats);
					});
				});

				const p2 = new Promise((resolve, reject) => {
					getBillingCustomer(
						{
							parentAccountId:
								CakeStore.getState().brand?.config?.partner_account_id,
						},
						(data) => {
							CakeStore.dispatch(setCustomer(data.data));
							resolve({ customer: data.data });
						},
						() => {
							resolve({ planType: null });
						}
					);
				});

				Promise.allSettled([p1, p2]).then((results) => {
					const opts = { account: data.account, user: data.user };
					results.forEach((result) => {
						if (result.value?.day) {
							opts.stats = { ...result.value };
						} else if (result.value?.customer) {
							opts.customer = result.value.customer;
						}
					});

					getAccountUsage(
						false,
						data.account.id,
						getUrlQueryParam("prev_limits"),
						(limitAndUsage) => {
							opts.limitAndUsage = limitAndUsage;
							this.identifyInit(opts, impersonate);
						},
						() => {
							this.identifyInit(opts, impersonate);
						}
					);
				});

				if (
					!skipAuthSetup &&
					(!data.account.address.address1 ||
						!data.account.address.city ||
						!data.account.address.country ||
						!data.account.address.postal_code)
				) {
					getAccountMetaDataService(
						{ id: data.account.id, name: ACCOUNT_META.ACCOUNT_SETUP },
						() => {
							CakeStore.dispatch(setAccountReady(true));
							CakeStore.dispatch(setAuthenticated(true));
						},
						(msg, response, code) => {
							if (code === 404) {
								CakeStore.dispatch(setAccountReady(false));
								CakeStore.dispatch(setAuthenticated(true));
								window.location =
									window.location.search + "#" + fetchRoute("accountSetup");
							}
						}
					);
				} else {
					CakeStore.dispatch(setAccountReady(true));
					CakeStore.dispatch(setAuthenticated(true));
				}

				if (getUrlQueryParam("brandPreview") === "true") {
					window.location = "#" + fetchRoute("brand");
				}

				removeLegacyParameterByName("via");
				removeLegacyParameterByName("planType");
				removeLegacyParameterByName("prev_limits");
				removeLegacyParameterByName("utm_campaign");
				removeLegacyParameterByName("utm_medium");
				removeLegacyParameterByName("utm_source");
				removeLegacyParameterByName("utm_content");
				removeLegacyParameterByName("phId");

				setTimeout(() => {
					this.tabActivated();
				}, 0);
				callback(data.account, data.user);
			},
			(message,error) => {
				console.log(error)
				CakeStore.dispatch(setAuthenticated(false));
				DialogHandler.show({
					type: "error",
					title: message ? (
						<Translate value={message} />
					) : (
						<Translate value="app-general-error-user-account_fetch" />
					),
				});
			}
		);
	}

	initAccountAndUser(account, user) {
		CakeStore.dispatch(setAccount(account));

		/*if (typeof profitwell !== "undefined") {
			profitwell("start", { user_id: user.id });
		}*/

		loadAppcues(user, account, this, () => {});

		CakeStore.dispatch(
			setUser({
				...this.props.user,
				...user,
			})
		);

		this.setTranslationLocale(user.language);
		moment.tz.setDefault(user.timezone);

		getAccountMetaDataService(
			{
				name: ACCOUNT_META.CAMPAIGN_WITH_BLUEPRINT,
			},
			(data) => {
				CakeStore.dispatch(
					setAccountMetadata(ACCOUNT_META.CAMPAIGN_WITH_BLUEPRINT, data.data)
				);
			},
			(msg, error, code) => {
				if (code === 404) {
					createAccountMetaDataService({
						id: account.id,
						name: ACCOUNT_META.CAMPAIGN_WITH_BLUEPRINT,
						content: {},
					});
				}
			}
		);
	}

	identifyInit(result = {}, impersonate = false) {
		if (segmentCondition(SEGMENT_EVENTS.IDENTIFY)) {
			let payload = {
				...result.user,
				accountId: result.account.id,
				lineage: result.account.lineage,
			};

			if (result.stats) {
				payload.stats = result.stats;
			}

			if (result.limitAndUsage) {
				payload.limitAndUsage = result.limitAndUsage;
			}

			if (result.customer) {
				payload.planType =
					result.customer?.subscriptions?.data?.length === 0
						? getPlanType()
						: getPlanType(result.customer?.subscription?.plan?.name);
				payload.customer = result.customer;
			}

			// eslint-disable-next-line no-undef
			analytics.identify(
				result.user.id,
				segmentPayloads(SEGMENT_EVENTS.IDENTIFY, payload)
			);

			posthog.identify(
				result.user.email,
				segmentPayloads(SEGMENT_EVENTS.IDENTIFY, payload)
			);
		}

		if (segmentCondition(SEGMENT_EVENTS.GROUP)) {
			// eslint-disable-next-line no-undef
			analytics.group(
				result.account.id,
				segmentPayloads(SEGMENT_EVENTS.GROUP, result.account)
			);

			posthog.group(
				"account",
				result.account.id,
				segmentPayloads(SEGMENT_EVENTS.GROUP, result.account)
			);
		}
		if (impersonate) {
			trackSegmentEvent(SEGMENT_EVENTS.IMPERSONATE, result.user);
		} else {
			trackSegmentEvent(SEGMENT_EVENTS.SIGN_IN, result.user);
		}
	}

	tabActivated(isUpdate = true) {
		//Usage stats for limits and notifications
		const state = CakeStore.getState();
		if (this.usageInterval == null && state.global.account) {
			this.usageInterval = setInterval(() => {
				getAccountUsage(isUpdate, state.global.account.id);
			}, this.state.intervals.usage);
		}
	}

	tabInactive() {
		//Usage stats for limits and notifications
		clearInterval(this.usageInterval);
		this.usageInterval = null;
	}

	logOut(redirection = false) {
		logoutService(
			null,
			() => {
				globalLogOut(redirection);
				this.validateSession();
			},
			() => {
				globalLogOut(redirection);
				this.validateSession();
			}
		);
	}

	render() {
		if (this.props.criticalError) {
			throw new CriticalError({
				buttonText: <Translate value="app-general-error-account-profile-B" />,
			});
		}

		const brandConfig = CakeStore.getState().brand?.config;
		const accountId = CakeStore.getState().global.account?.id;
		const isPartner =
			CakeStore.getState().global?.account?.partner &&
			this.state.previewingBrand === false;

		const authenticated = this.props.authenticated;
		const accountReady = this.props.accountReady;

		return (
			<div className="UiContainer">
				<Notification ref="Notification" />
				<Dialog ref="Dialog" />
				<Overlay ref="Overlay" />
				<TaskBar ref="Taskbar" />
				<FullPageLoader ref="fullPageLoader" logoUrl={this.props.logo} />
				{CakeStore.getState().brand && this.state.translations && (
					<>
						<Switch>
							<Route
								path={fetchRoute("emailCreation")}
								render={() => {
									return (
										<OnboardingEmailEditor
											fetchAccount={this.fetchAccount}
											history={this.props.history}
										/>
									);
								}}
							/>

							<HashRouter>
								<Switch>
									<Route
										path={fetchRoute("errorFallback")}
										render={() => <BlockedUser logOut={this.logOut} />}
									/>

									<Route
										path={fetchRoute("public")}
										render={() => <PublicHash />}
									/>

									<Route
										path="/auth"
										render={() => (
											<AuthFlow
												authenticated={authenticated}
												accountReady={accountReady}
												handleState={this.handleState}
												fetchAccount={this.fetchAccount}
												logOut={this.logOut}
											/>
										)}
									/>

									{authenticated === true &&
										accountReady === true &&
										!isMobile && (
											<>
												<Route
													path="/"
													render={() => <Menu logOut={this.logOut} />}
												/>
												<Suspense fallback={<SpinnerContainer pageCenter />}>
													{!isPartner && (
														<Switch>
															<Route
																path={fetchRoute("dashboard")}
																render={() => <Dashboard />}
															/>
															<Route
																path={fetchRoute("contacts")}
																render={(props) => <Contacts />}
															/>
															<Route
																path={fetchRoute("lists")}
																render={() => <Lists />}
															/>
															<Route
																path={fetchRoute("forms")}
																render={() => <Forms />}
															/>
															<Route
																path={fetchRoute("campaigns")}
																render={() => <Campaigns />}
															/>
															<Route
																path={fetchRoute("automation")}
																render={() => <Automation />}
															/>
															<Route
																path={fetchRoute("profile")}
																render={() => <Account logOut={this.logOut} />}
															/>

															<Route
																path={fetchRoute("brand")}
																render={() => (
																	<Brand
																		setPreviewingBrand={this.setPreviewingBrand}
																	/>
																)}
															/>

															<Redirect to={fetchRoute("dashboard")} />
														</Switch>
													)}

													{isPartner && (
														<Switch>
															<Route
																path={fetchRoute("dashboard")}
																render={() => <ResellerDashboard />}
															/>

															<Route
																path={fetchRoute("profile")}
																render={() => <Account logOut={this.logOut} />}
															/>

															<Route
																path={fetchRoute("brand")}
																render={() => (
																	<Brand
																		setPreviewingBrand={this.setPreviewingBrand}
																	/>
																)}
															/>

															<Redirect to={fetchRoute("dashboard")} />
														</Switch>
													)}
												</Suspense>
											</>
										)}

									{authenticated === true && accountReady === true && isMobile && (
										<Switch>
											<Route
												path={fetchRoute("noMobile")}
												render={() => <NoMobile logOut={this.logOut} />}
											/>

											<Redirect to={fetchRoute("noMobile")} />
										</Switch>
									)}

									{authenticated === false && (
										<Redirect
											to={{
												pathname: fetchRoute("signIn"),
												search:
													location.hash !== "#/auth/signin" &&
													location.hash !== "#/" &&
													`?continue=${encodeURIComponent(location.hash)}`,
											}}
										/>
									)}
								</Switch>
							</HashRouter>
						</Switch>
						<TaskBarContainer />
					</>
				)}
			</div>
		);
	}
}

UI.propTypes = {
	sessionCookieLabel: PropTypes.string,
	sessionRefreshCookieLabel: PropTypes.string,
};

UI.defaultProps = {
	sessionCookieLabel: process.env.SESSION_COOKIE_LABEL,
	sessionRefreshCookieLabel: process.env.SESSION_REFRESH_COOKIE_LABEL,
};

export default connect((state) => {
	return {
		logo: state.brand?.images?.logo,
		criticalError: state.criticalError,
		isDefaultBrand: state.brand?.name ? state.brand.name === "Cakemail" : false,
		user: state.global.user,
		authenticated: state.global.authenticated,
		accountReady: state.global.accountReady,
	};
}, null)(UI);
